import { getData, postData } from '@/utils/api';
import { checkAuthTokens } from '@/utils/sessions';

export const getServiceMessage =  async () => {
  try {
    const { jwttoken } = checkAuthTokens();

    const response = await getData({auth: jwttoken, endpoint: '/service-message'});

    if (response.error) {
      throw(new Error(response.title));
    }

    return {error: false, data: response.content};

  } catch (err) {
    return { error: true, message: err.message};
  }
};

export const postServiceMessage =  async (data) => {
  try {
    const { jwttoken } = checkAuthTokens();

    const response = await postData({auth: jwttoken, endpoint: '/service-message', data});

    if (response.error) {
      console.log({response});

      throw(new Error(response.message));
    }

    return {error: false};

  } catch (err) {
    console.log({err: err.message});

    return { error: true, message: err.message};
  }
};